"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ellipsis = void 0;
exports.ellipsis = {
    multiFeeDistribution: '0x4076CC26EFeE47825917D0feC3A79d0bB9a6bB5c',
};
